import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl font-semibold tracking-tight">
              GTBuy<span className="text-primary-400">.</span>
            </Link>
            <p className="mt-3 text-sm text-background-200/70 leading-relaxed">
              Your smart shopping agent comparison tool. Find the best deals across GTBuy, Kakobuy, Superbuy and more.
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-200/70 hover:text-primary-400 transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/what-is-gtbuy-spreadsheet" className="text-sm text-background-200/70 hover:text-primary-400 transition-colors cursor-pointer">
                  What is GTBuy Spreadsheet
                </Link>
              </li>
              <li>
                <Link to="/article/gtbuy-vs-kakobuy" className="text-sm text-background-200/70 hover:text-primary-400 transition-colors cursor-pointer">
                  GTBuy vs Kakobuy
                </Link>
              </li>
              <li>
                <Link to="/article/international-shopping-guide" className="text-sm text-background-200/70 hover:text-primary-400 transition-colors cursor-pointer">
                  International Shopping Guide
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">Shop Categories</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-200/70 hover:text-primary-400 transition-colors">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-200/70 hover:text-primary-400 transition-colors">
                  Hoodies &amp; Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-200/70 hover:text-primary-400 transition-colors">
                  T-Shirts
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-200/70 hover:text-primary-400 transition-colors">
                  Jackets
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">Main Site</h4>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              Visit Kaspreadsheet
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
        <div className="border-t border-background-200/20 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/50">
            &copy; {new Date().getFullYear()} GTBuy Team. All rights reserved.
          </p>
          <p className="text-xs text-background-200/50">
            External links open on <strong>kaspreadsheet.com</strong>
          </p>
        </div>
      </div>
    </footer>
  );
}